// extracted by mini-css-extract-plugin
export default {"body":"styles_body__1cfb-","empty":"styles_empty__intFQ"};